import styled from 'styled-components';

export const Main = styled.main`
  position: relative;
  min-height: 100vh;
  height: 100vh;
  background-color: #ffffff;

  &::before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 50%;
    bottom: 0;
    height: 100%;
    background-color: ${({ theme: { colors } }) => colors.lightGrey};

    @media (max-width: 979px) {
      content: none;
      display: none;
    }
  }

  & > div {
    position: relative;
    z-index: 1;
    height: 100%;
  }

  .login-banner {
    height: 100vh;
    background-image: url('/assets/img/login.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .login-row {
    height: 100%;
    margin: 0;

    @media (max-width: 979px) {
      overflow: auto;
    }

    & > div {
      max-width: 50%;
      margin: 0;

      &:first-child {
        position: relative;
      }

      &:last-child {
        overflow: auto;
        height: 100%;
        padding: 20px 0;
      }

      @media (max-width: 979px) {
        max-width: 100%;
        padding: 30px 0;

        &:first-child {
          display: none;
        }
      }
    }
  }

  h1 {
    margin: 0;
  }

  h2 {
    font-size: 46px;
    font-weight: 700;
    margin-top: 80px;
    margin-bottom: 20px;

    @media (max-width: 767px) {
      font-size: 34px;
      margin-top: 50px;
    }
  }

  h3 {
    font-size: 32px;
    margin-top: 115px;
    margin-bottom: 40px;
    font-weight: bold;
  }

  video {
    height: 100%;
    max-height: 100vh;
  }

  .login-container {
    max-width: 470px;
    min-height: 550px;
    margin: auto;
    margin-left: 115px;
    width: 100%;

    @media (max-width: 1200px) {
      margin-left: 10%;
      max-width: 40vw;
    }

    @media (max-width: 979px) {
      max-width: 90vw;
      margin: auto;
    }
  }

  .resend-link {
    color: ${({ theme: { colors } }) => colors.blue};

    &:hover {
      color: ${({ theme: { colors } }) => colors.blueHover};
    }

    &:focus {
      text-decoration: underline;
    }
  }

  .or-use-text {
    color: ${({ theme: { colors } }) => colors.darkBlue};
    opacity: 0.6;
    margin-bottom: 34px;
    font-size: 15px;
  }

  .signup-offer {
    display: inline-block;
    background-color: #f0eefe;
    padding: 7px 13px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.25px;
  }

  .trusted-by {
    margin-top: 100px;

    & > span {
      display: block;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .clients {
      overflow: hidden;
    }

    .client {
      &-content {
        display: flex;
        animation: scrolling 10s linear infinite;
      }

      &-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        flex: 0 0 150px;

        img {
          display: block;
          max-width: 150px;
          width: 100%;
          padding: 0 20px;
          image-rendering: -webkit-optimize-contrast;
        }
      }
    }

    @keyframes scrolling {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translatex(-900px);
      }
    }
  }
`;
